export const isEmptyValidator = (values: string[]) => values.every((v: string) => v.trim() !== '' || v.trim() !== '0');
